var _path, _path2, _path3;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCameraError(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    height: 40,
    width: 40,
    viewBox: "0 0 40 40",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M20 10.88C14.97 10.88 10.88 14.97 10.88 20 10.88 22.7 12.07 25.13 13.94 26.8L15 25.75C13.4 24.35 12.38 22.3 12.38 20 12.38 15.78 15.78 12.38 20 12.38 22.33 12.38 24.4 13.42 25.8 15.05L26.86 14C25.18 12.09 22.73 10.88 20 10.88zM27.86 15.4L26.76 16.49C27.31 17.54 27.62 18.73 27.62 20 27.62 24.22 24.22 27.62 20 27.62 18.7 27.62 17.49 27.3 16.42 26.73L15.33 27.82C16.7 28.64 18.29 29.12 20 29.12 25.03 29.12 29.12 25.03 29.12 20 29.12 18.32 28.66 16.75 27.86 15.4z",
    style: {
      baselineShift: "baseline",
      colorInterpolationFilters: "linearRGB",
      colorInterpolation: "sRGB",
      colorRendering: "auto",
      direction: "ltr",
      dominantBaseline: "auto",
      fontFamily: "sans-serif",
      fontFeatureSettings: "normal",
      fontSize: "medium",
      fontVariantAlternates: "normal",
      fontVariantCaps: "normal",
      fontVariantLigatures: "normal",
      fontVariantNumeric: "normal",
      fontVariantPosition: "normal",
      imageRendering: "auto",
      isolation: "auto",
      letterSpacing: "normal",
      lineHeight: "normal",
      mixBlendMode: "normal",
      paintOrder: "fill markers stroke",
      shapePadding: 0,
      shapeRendering: "auto",
      solidColor: "#000",
      solidOpacity: 1,
      strokeWidth: 2,
      textAlign: "start",
      textDecorationColor: "#000",
      textDecorationLine: "none",
      textDecorationStyle: "solid",
      textDecoration: "none",
      textIndent: 0,
      textOrientation: "mixed",
      textRendering: "auto",
      textTransform: "none",
      vectorEffect: "none",
      whiteSpace: "normal",
      wordSpacing: "normal"
    }
  }), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m16 5.1c-0.9 0-1.9 0.6-2.3 1.4L12.6 8.7C12.5 8.8 12.2 9 12 9H6C4.3 9 3 10.3 3 12v18c0 1.7 1.3 3 3 3H7.65L9.67 31H6C5.4 31 5 30.6 5 30V12c0-0.6 0.4-1 1-1h6c0.9 0 1.9-0.6 2.3-1.5L15.4 7.3C15.5 7.2 15.8 7 16 7h8c0.2 0 0.5 0.2 0.6 0.4l1.1 2.2c0.4 0.8 1.4 1.4 2.3 1.4h1.85L31.87 9H28C27.8 9 27.5 8.9 27.4 8.7L26.3 6.5C25.9 5.7 24.9 5.1 24 5.1ZM34.26 9.03 32.27 11H34c0.6 0 1 0.4 1 1v18c0 0.6-0.4 1-1 1H12.08l-2.02 2H34c1.7 0 3-1.3 3-3V12C37 10.39 35.83 9.15 34.26 9.03Zm-3.44 3.4-1.4 1.39c0.17 0.12 0.37 0.18 0.58 0.18 0.55 0 1-0.45 1-1 0-0.2-0.06-0.4-0.18-0.57z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "m7 7h4V8H7Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "m20 16v-1c-2.8 0-5 2.2-5 5h1c0-2.2 1.8-4 4-4z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M37.79 1.18 1.01 37.62 2.21 38.82 38.99 2.38Z",
    style: {
      baselineShift: "baseline",
      colorInterpolationFilters: "linearRGB",
      colorInterpolation: "sRGB",
      colorRendering: "auto",
      direction: "ltr",
      dominantBaseline: "auto",
      fontFamily: "sans-serif",
      fontFeatureSettings: "normal",
      fontSize: "medium",
      fontVariantAlternates: "normal",
      fontVariantCaps: "normal",
      fontVariantLigatures: "normal",
      fontVariantNumeric: "normal",
      fontVariantPosition: "normal",
      imageRendering: "auto",
      isolation: "auto",
      letterSpacing: "normal",
      lineHeight: "normal",
      mixBlendMode: "normal",
      shapePadding: 0,
      shapeRendering: "auto",
      solidColor: "#000",
      solidOpacity: 1,
      strokeWidth: 2,
      textAlign: "start",
      textDecorationColor: "#000",
      textDecorationLine: "none",
      textDecorationStyle: "solid",
      textDecoration: "none",
      textIndent: 0,
      textOrientation: "mixed",
      textRendering: "auto",
      textTransform: "none",
      vectorEffect: "none",
      whiteSpace: "normal",
      wordSpacing: "normal"
    }
  }));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCameraError);
export default __webpack_public_path__ + "static/media/camera-error.aa1e7f7ab3453b38a1b639c94cbc1bf3.svg";
export { ForwardRef as ReactComponent };